import { render, staticRenderFns } from "./HKLPinBadge.vue?vue&type=template&id=4607b7cb&scoped=true&"
import script from "./HKLPinBadge.vue?vue&type=script&lang=js&"
export * from "./HKLPinBadge.vue?vue&type=script&lang=js&"
import style0 from "./HKLPinBadge.vue?vue&type=style&index=0&id=4607b7cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607b7cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4607b7cb')) {
      api.createRecord('4607b7cb', component.options)
    } else {
      api.reload('4607b7cb', component.options)
    }
    module.hot.accept("./HKLPinBadge.vue?vue&type=template&id=4607b7cb&scoped=true&", function () {
      api.rerender('4607b7cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Badge/HKLPinBadge.vue"
export default component.exports